module.exports = __webpack_public_path__ + "static/london-d5ce52e7a09dc33f113e570d035c3a67.jpg";